import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "var(--sc-cream)",
          fontFamily: "JetBrains Mono, monospace",
          fontSize: 13,
          color: "var(--sc-muted)",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
        }}
      >
        Loading your paisa…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
